import { shallowEqual } from 'react-redux';

import { Box, Card, Icon } from '@zillow/constellation-10';
import { IconHandshakeFilled } from '@zillow/constellation-icons';
import { LoadingText } from '@zg-rentals/loading-components';

import { useSelector } from '../../../../selectors/useSelector';

import EmptyState from '../../../EmptyState';
import GeneratedLeaseUpsell from '../GeneratedLeaseUpsell';

type Props = {
  isLoading?: boolean;
  isEligibleForGeneratedLease?: boolean;
  propertyState?: string;
};

const EmptyLeasesCardSimple = ({ isLoading = false, isEligibleForGeneratedLease = false, propertyState }: Props) => {
  const { isLeaseBuilderRestricted } = useSelector((state) => {
    return {
      isLeaseBuilderRestricted: state.properties.currentProperty.restrictions.isLeaseBuilderRestricted,
    };
  }, shallowEqual);

  const bodyContent = isLeaseBuilderRestricted ? 'Upload a lease' : 'Upload or create a lease';

  if (isEligibleForGeneratedLease) {
    return <GeneratedLeaseUpsell state={propertyState} />;
  }

  if (isLoading) {
    return (
      <Card
        data-testid="EmptyLeasesCardSimple"
        tone="neutral"
        elevated={false}
        css={{ paddingInline: 'looser', paddingBlock: 'loosest' }}
      >
        <Box aria-hidden="true" css={{ marginBottom: 'default' }}>
          <Icon size="md" css={{ color: 'icon.subtle' }} render={<IconHandshakeFilled />} />
        </Box>
        <LoadingText
          textStyle="heading-xs"
          loadingWidth="100%"
          isLoading
          css={{ marginBottom: 'tightest', display: 'block' }}
        >
          Active leases will appear here
        </LoadingText>
        <LoadingText loadingWidth="75%" isLoading>
          {bodyContent}
        </LoadingText>
      </Card>
    );
  }

  return (
    <EmptyState
      data-testid="EmptyLeasesCardSimple"
      icon={<Icon size="md" css={{ color: 'icon.subtle' }} render={<IconHandshakeFilled />} />}
      heading="Active leases will appear here"
      headingLevel={4}
      body={bodyContent}
      align="left"
    />
  );
};

export default EmptyLeasesCardSimple;
